
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import { Container, Row, Col, Card, CardBody, Button, CardImg } from "reactstrap";
import SF3 from "assets/img/img-livenyte/sf3.jpg"
import { Link } from "react-router-dom";
import noImage from "assets/img/img-livenyte/LiveNyteNoImage.jpg";

class TicketsHeader extends React.Component {
    render() {
        const { eventID, backgroundImage, dropdownOptions } = this.props
        return (
            <>
                <div>
                    <Col className="ml-auto mr-auto text-center">
                        <span className="mask opacity-8 blur"
                            style={{
                                backgroundImage: `url(${this.props.backgroundImage})`,
                            }}
                        />
                        {dropdownOptions &&
                            <CardBody className="py-0">
                                <Row className="content-top cursor-pointer mr-0 mt-4" style={{ position: "absolute", right: "0" }} >
                                    <Col className="text-right mr-2">
                                        {dropdownOptions}
                                    </Col>
                                </Row>
                            </CardBody>
                        }
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="ml-auto mr-auto px-0 ">
                            <br />
                            <CardImg
                                alt="..."
                                src={this.props.backgroundImage}
                                onError={(e) => { e.target.onerror = null; e.target.src = noImage }}
                                style={{
                                    maxWidth: "724px",
                                    maxHeight: "378px",
                                    zIndex: '99',
                                    borderRadius: '0.375rem',
                                    objectFit: "cover"
                                }}
                                className="exampleDarkGlass"
                                top
                            />
                        </Col>
                    </Col>
                </div>
            </>
        );
    }
}

TicketsHeader.propTypes = {
    title: PropTypes.string,
    lead: PropTypes.string,
    backgroundImage: PropTypes.string,
    eventID: PropTypes.string,
};

export default TicketsHeader;
